let isFetching = false;
var CartProgressBar = class extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.target = document.querySelector("cart-drawer");
      this.total = Number(
        document.querySelector(".progress-bar__wrapper").dataset.total
      );

      if (this.total >= 0) {
        this.lineItems = this.target.querySelectorAll("line-item.line-item");

        this.goals = Array.from(
          document.querySelectorAll(".progress-bar__goal")
        ).map((goal) => {
          return {
            goal: Number(goal.dataset.goal),
            id: goal.dataset.product,
          };
        });
        this.itemsInCart = Array.from(this.lineItems).map((lineItem) => {
          return {
            id: lineItem.dataset.product,
            quantity: Number(lineItem.dataset.quantity),
            price: Number(lineItem.dataset.price),
            line: lineItem.dataset.line,
          };
        });

        this.nonFreeProducts = Array.from(this.itemsInCart).filter(
          (lineItem) => {
            return Number(lineItem.price) > 1;
          }
        );

        this.freeProducts = Array.from(this.itemsInCart).filter((lineItem) => {
          return Number(lineItem.price) === 0 || Number(lineItem.price) === 1;
        });

        this.removeFromCartProducts = [
          ...this.freeProducts.filter((line) => {
            return this.goals.some((pos) => {
              return pos.id === line.id && pos.goal > this.total;
            });
          }),
          ,
          ...this.freeProducts.filter((line) => line.quantity > 1),
        ].filter((el) => el);

        this.addToCartProducts = this.goals.filter((goal) => {
          return (
            goal.goal < this.total &&
            !this.itemsInCart.some((lineItem) => goal.id === lineItem.id) &&
            goal.id !== "FREESHIPPING"
          );
        });

        let response;
        const promises = [];
        // remove unnecessary products from cart
        this.removeFromCartProducts.map((productToRemove) => {
          const promise = this._changeCart(
            productToRemove,
            productToRemove.quantity > 1 ? 1 : 0
          ).then((res) => res);
          promises.push(promise);
        });

        // add only relevant products, all at once
        if (this.addToCartProducts.length > 0 && !isFetching) {
          for (let p of this.addToCartProducts) {
            const promise = this._addToCart(p).then((res) => {
              isFetching = false;
              return res;
            });
            promises.push(promise);
          }
        }

        // Wait for all operations to complete
        Promise.allSettled(promises)
          .then((results) => {
            let toReloadCart = false;
            results.forEach((result) => {
              if (result.status === "rejected") {
                console.error("An error occurred:", result.reason);
              } else {
                toReloadCart = true;
                response = result.value;
              }
            });
            if (toReloadCart) {
              reloadCart(response);
            }
          })
          .catch((error) => {

          });
      }
    }, 500); //todo: delete after test
  }
  async _changeCart(product, quantity) {
    let formData = {
      line: Number(product.line),
      quantity,
      sections: "cart-drawer",
    };
    try {
      return await fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }).then((res) => {
        if (!res.ok) {
          throw new Error("HTTP Error", res);
        }
        return res.json();
      });
    } catch (err) {
      // Error handling silently
    }
  }

  async _addToCart(p) {
    const formData = {
      items: [{ id: p.id, quantity: 1 }],
      sections: ["cart-drawer"],
    };
    return await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    }).then((res) => {
      if (!res.ok) {
        throw new Error("HTTP Error", res);
      }
      return res.json();
    });
  }
};

window.customElements.define("cart-progress-bar", CartProgressBar);

function reloadCart(response) {
  if (
    response &&
    response.sections &&
    response.sections["cart-drawer"] &&
    document.querySelector("cart-drawer")
  ) {
    document.querySelector("cart-drawer").innerHTML = new DOMParser()
      .parseFromString(response.sections["cart-drawer"], "text/html")
      .querySelector(".cart-drawer").innerHTML;
  }
}
